import Vue from 'vue';
import VueStatic from 'vue-static';

Vue.use(VueStatic);
